import WebSocketWrapper from '@/utils/web-socket/websocket-wrapper';

export const bikeReupdateFw = {
  data () {
    return {
      ws: '',
      timeInterval: null,
      nowPartUpdate: '',
      isUnplugDongle: false
    };
  },
  mounted () {
    const wsUrl = 'ws://127.0.0.1:58000/';
    const apiCustomer = 'BR';
    const apiKey =
        '30f239bf561b7e33b94bf6370926341c83efa84102be92027601a74a2ae1160b';
    this.ws = new WebSocketWrapper(wsUrl, apiCustomer, apiKey);

    /**
       * connect 連結websocket，建立通道
       */
    this.boolLoading = true;
    this.ws.connect();

    this.ws.onConnected = data => {
      this.ws.CheckComport();
    };

    /**
       * CheckComponrt 檢查是否接上Dongle
       */
    this.ws.onCheckComport = data => {
      if (data.Status === 1000) {
        if (this.isUnplugDongle) {
          this.funcCloseDialog();
          if (!this.funcCheckIsFinalStep()) {
            // console.log('Update Next.')
            this.funcCheckNextStep();
          }
          this.isUnplugDongle = false;
        } else {
          this.ws.CheckPower();
        }
      } else {
        if (this.isUnplugDongle) {
          this.hideFooter = true;
          let msg = this.$t('reUpdate.msg.connectDongle');
          this.funcOpenDialog(msg);
          this.ws.CheckComport();
        } else {
          this.ws.CheckComport();
        }
      }
    };

    this.ws.onDisconnected = data => {
      // const strError = 'Please open message gateway'
      // this.$router.push('/connect/failed')
    };

    /**
       * CheckPower / onCheckPower 檢查是否接上開啟電源
       */
    this.ws.onCheckPower = data => {
      // console.log("TCL: mounted -> onCheckPower", data)
      if (data.Status === 1000) {
        switch (this.nowPartUpdate) {
          case 'C':
            if (!this.funcCheckIsFinalStep()) {
              // console.log('Update Next.')
              this.funcCheckNextStep();
            }
            break;
          case 'D':
            this.ws.ReadPara();
            break;
          default:
            this.funcGetBikeInfoApi();
        }
      } else {
        if (this.nowPartUpdate === 'C') {
          this.hideFooter = true;
          let errorCode = '30002-1';
          let msg = this.$t('errorCodeMsg.' + errorCode);
          this.funcOpenDialog(msg);
        }
        this.ws.CheckPower();
      }
    };
    this.ws.onUpgradeConsole = data => {
      // status, P:進行中, S:成功, F:失敗
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      this.nowPartUpdate = 'C';
      let updateMsg = '';
      // console.log("TCL: mounted -> onUpgradeConsole", data)
      if (data.Status === 1000) {
        updateMsg = this.$t('update.table.updateModal.success');
        this.funcChangeUpgradeStatus('C', 'S', updateMsg, 100);
        this.mustUpgradeParts.shift();
        this.ws.CheckPower();
        /**
             * Bug 以下程式可以刪除
             */

        // if(!this.funcCheckIsFinalStep()){
        //   this.funcCheckNextStep()
        // }

        // 更新完成
      } else if (data.Status === 1200) {
        updateMsg = this.$t('update.table.updateModal.ready');
        this.funcChangeUpgradeStatus('C', 'P', updateMsg);
        // 更新初始化
      } else if (data.Status === 1201) {
        updateMsg = this.$t('update.table.updateModal.updating');
        this.funcChangeUpgradeStatus('C', 'P', updateMsg, data.Progress);
        // 更新中
      } else if (data.Status === 1001) {
        if (data.ErrorCode === 30001) {
          this.ws.CheckComport();
          this.isUnplugDongle = true;
        }
        updateMsg = '[' + data.ErrorCode + ']' + this.$t('update.table.updateModal.failed');
        this.funcChangeUpgradeStatus('C', 'F', updateMsg);
        // 更新失敗
      }
    };
    this.ws.onUpgradeDisplay = data => {
      // status, P:進行中, S:成功, F:失敗
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      this.nowPartUpdate = 'P';
      let updateMsg = '';
      // console.log("TCL: mounted -> onUpgradeConsole", data)
      if (data.Status === 1000) {
        // 更新完成
        updateMsg = this.$t('update.table.updateModal.success');
        this.funcChangeUpgradeStatus('P', 'S', updateMsg, 100);
        this.mustUpgradeParts.shift();
        if (!this.funcCheckIsFinalStep()) {
          this.funcCheckNextStep();
        }
      } else if (data.Status === 1200) {
        // 更新初始化
        updateMsg = this.$t('update.table.updateModal.ready');
        this.funcChangeUpgradeStatus('P', 'P', updateMsg);
      } else if (data.Status === 1201) {
        // 更新中
        updateMsg = this.$t('update.table.updateModal.updating');
        this.funcChangeUpgradeStatus('P', 'P', updateMsg, data.Progress);
      } else if (data.Status === 1001) {
        if (data.ErrorCode === 30001) {
          this.ws.CheckComport();
          this.isUnplugDongle = true;
        }
        updateMsg = '[' + data.ErrorCode + ']' + this.$t('update.table.updateModal.failed');
        this.funcChangeUpgradeStatus('P', 'F', updateMsg);
        // 更新失敗
      }
    };
    this.ws.onUpgradeDriver = data => {
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      // status, P:進行中, S:成功, F:失敗
      this.nowPartUpdate = 'D';
      let updateMsg = '';
      // console.log("TCL: mounted -> onUpgradeConsole", data)
      if (data.Status === 1000) {
        updateMsg = this.$t('update.table.updateModal.success');
        this.funcChangeUpgradeStatus('D', 'S', updateMsg, 100);
        this.hideFooter = true;
        let msg = this.$t('reUpdate.msg.pleasewait');
        this.funcOpenDialog(msg);
        this.ws.ChangeBike();
        // 更新完成
      } else if (data.Status === 1200) {
        updateMsg = this.$t('update.table.updateModal.ready');
        this.funcChangeUpgradeStatus('D', 'P', updateMsg);
        // 更新初始化
      } else if (data.Status === 1201) {
        updateMsg = this.$t('update.table.updateModal.updating');
        this.funcChangeUpgradeStatus('D', 'P', updateMsg, data.Progress);
        // 更新中
      } else if (data.Status === 1001) {
        if (data.ErrorCode === 30001) {
          this.ws.CheckComport();
          this.isUnplugDongle = true;
        }
        updateMsg = '[' + data.ErrorCode + ']' + this.$t('update.table.updateModal.failed');
        this.funcChangeUpgradeStatus('D', 'F', updateMsg);
        // 更新失敗
      }
    };
    this.ws.onUpgradeBroseDrive = data => {
      // status, P:進行中, S:成功, F:失敗
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      this.nowPartUpdate = 'M';
      let updateMsg = '';
      // console.log("TCL: mounted -> onUpgradeConsole", data)
      if (data.Status === 1000) {
        updateMsg = this.$t('update.table.updateModal.success');
        this.funcChangeUpgradeStatus('M', 'S', updateMsg, 100);
        this.mustUpgradeParts.shift();
        if (!this.funcCheckIsFinalStep()) {
          this.funcCheckNextStep();
        }
        // 更新完成
      } else if (data.Status === 1200) {
        updateMsg = this.$t('update.table.updateModal.ready');
        this.funcChangeUpgradeStatus('M', 'P', updateMsg);
        // 更新初始化
      } else if (data.Status === 1201) {
        updateMsg = this.$t('update.table.updateModal.updating');
        this.funcChangeUpgradeStatus('M', 'P', updateMsg, data.Progress);
        // 更新中
      } else if (data.Status === 1001) {
        if (data.ErrorCode === 30001) {
          this.ws.CheckComport();
          this.isUnplugDongle = true;
        }
        updateMsg = '[' + data.ErrorCode + ']' + this.$t('update.table.updateModal.failed');
        this.funcChangeUpgradeStatus('M', 'F', updateMsg);
        // 更新失敗
      }
    };
    this.ws.onReadPara = data => {
      // console.log('onReadPara',data)
      if (data.Status === 1000) {
        this.ws.WriteMid('D', this.bikeInfo.DriverMID);
      } else {
        this.ws.ReadPara();
      }
    };
    this.ws.onChangeBike = data => {
      // console.log('onChangeBike',data)
      if (data.Status === 1000) {
        this.ws.CheckPower();
      } else {
        this.ws.ChangeBike();
      }
    };
    this.ws.onWriteMid = data => {
      // console.log('WriteMID', data)
      if (data.Status === 1000) {
        this.mustUpgradeParts.shift();
        if (!this.funcCheckIsFinalStep()) {
          this.funcCheckNextStep();
        }
      } else {
        let msg = this.$t('reUpdate.writeMIDFail');
        this.funcChangeUpgradeStatus('D', 'F', msg);
      }
    };
  },
  beforeDestroy () {
    this.ws.disconnect();
    // console.log('connect page over')
  }
};
